const breakPoint = 767;
let resizeFlag   = false;
let windowWidth  = window.innerWidth;
let windowHeight = window.innerHeight;
let windowWidthJ = $(window).width();


// preload
const preload = () =>{
  $(window).on('load' , function() {
    $("body").removeClass("preload");
  });
};


// ------------------------------------------------------------------------
// anchorLink
// ----- BOTH
// ------------------------------------------------------------------------
const anchorLink = () => {
  $("a[href^='#']").on("click", function(){
    var linkSpeed    = 800;
    var linkHref     = $(this).attr("href");
    var linkTarget   = $(linkHref == "#" || linkHref == "" ? 'html' : linkHref);
    var linkAdjust   = 77;
    var linkPosition = linkTarget.offset().top;
    $("html, body").animate({scrollTop: linkPosition - linkAdjust}, linkSpeed, "swing");
    return false;
  });
};


// ------------------------------------------------------------------------
// toggleHeader
// ----- BOTH
// ------------------------------------------------------------------------
const toggleHeader = () => {

  let headerFlag        = false;
  // let stHeader  = document.getElementById('st-Header');
  let stHeaderNav  = document.getElementById('st-Header_Nav');
  let headerButton  = document.getElementById('st-Menu');

  headerButton.addEventListener('click', () => {

    if(!headerFlag){
      $('#st-Header_Nav').css({'display':'block'});
      setTimeout(function(){
        // stHeader.classList.remove('closed');
        stHeaderNav.classList.add('opend');
        headerButton.classList.add('opend');
        headerFlag = true;
  		},100);
    }else{
      stHeaderNav.classList.remove('opend');
      headerButton.classList.remove('opend');
      // stHeader.classList.add('closed');
      headerFlag = false;
      setTimeout(function(){
        $('#st-Header_Nav').css({'display':'none'});
  		},200);

    }
  }, false);

  // スクロールで縮める
$(window).on("scroll", function(){
  var scrollPosition = $(window).scrollTop();
    if(scrollPosition >= 33){
      $("#st-Header").addClass('st-Header-Shorten');
    } else {
      $("#st-Header").removeClass('st-Header-Shorten');
    }
});

};


// ------------------------------------------------------------------------
// showKV
// ----- BOTH
// ------------------------------------------------------------------------
const showKV = () => {

  //読み込みが完了
  $(window).on('load', function(){

    $('#index-Loading').stop().animate({'opacity':0}, 1500, 'linear', function(){
      $('#index-Loading').remove();
    });

  });//load

};


// ------------------------------------------------------------------------
// pageTop
// ----- BOTH
// ------------------------------------------------------------------------
const pageTop = () => {

  let PageTop = $("#st-Pagetop");
  let Scroll = $("#index-Scroll");
  var linkSpeed    = 500;



  $(window).on("scroll", function(){
    var scrollPosition = $(window).scrollTop();
      if(scrollPosition >= 50){
        PageTop.removeClass('st-Pagetop-Hidden');
      } else {
        PageTop.addClass('st-Pagetop-Hidden');
      }
  });

  PageTop.on("click", function(){
    $("html, body").animate({scrollTop: 0}, linkSpeed, "easeInOutCubic");
    return false;
  });


  Scroll.on("click", function(){

    var indexH          = $('#index-Mainvisual').height();

    //下にスクロール
    var windowH = $(window).height();
    $("html, body").animate({scrollTop: indexH + 40}, linkSpeed, "easeInOutCubic");
    return false;

  });
}


// ------------------------------------------------------------------------
// errorImages
// ----- BOTH
// ------------------------------------------------------------------------
const errorImages = () => {

  var images = [
      '404_kaoru.jpg',
      '404_maya.jpg',
      '404_moca.jpg',
      '404_rinko.jpg',
      '404_tae.jpg'
  ]

  var randImg = images[Math.floor(Math.random() * images.length)];
  var imagePath = path + '/assets/images/common/error/';
  $('.randomImages').attr('src',  imagePath + randImg);

}

export {
  preload,
  anchorLink,
  toggleHeader,
  showKV,
  pageTop,
  errorImages
}



// WEBPACK FOOTER //
// ./src/en_bang-dream_v0/assets/js/include/module.js